var map = {
	"./account.svg": "ef22",
	"./bar.svg": "d1a3",
	"./color.svg": "03ab",
	"./components.svg": "e3b6",
	"./dashboard.svg": "f782",
	"./example.svg": "30c3",
	"./excel.svg": "6599",
	"./export.svg": "077e",
	"./eye-open.svg": "d7ec",
	"./eye.svg": "4df5",
	"./eyeOpen.svg": "348e",
	"./form.svg": "eb1b",
	"./graph.svg": "5192",
	"./hcoin.svg": "7799",
	"./home.svg": "6bbe",
	"./line.svg": "4b7d",
	"./link.svg": "18f0",
	"./lock.svg": "ab00",
	"./nested.svg": "dcf8",
	"./password.svg": "2a3d",
	"./pdf.svg": "f9a1",
	"./personnel.svg": "33ce",
	"./pie.svg": "9ab6",
	"./privilege.svg": "78ab",
	"./project.svg": "69e4",
	"./rich.svg": "3ee1",
	"./role.svg": "520c",
	"./search.svg": "8e8d",
	"./setting.svg": "05ff",
	"./shousu.svg": "037d",
	"./skill.svg": "096e",
	"./star.svg": "708a",
	"./table.svg": "47f1",
	"./tree.svg": "93cd",
	"./user.svg": "b3b5",
	"./validate.svg": "62e48",
	"./visualization.svg": "1bec",
	"./wallet.svg": "402b",
	"./wechat.svg": "80da",
	"./zip.svg": "8aa6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";